import React, { useCallback, useMemo } from 'react';
import { PAGINATION_OPTIONS } from '../../../../../utils/fn/medias';
import MediaActions from './MediaActions';
import MediaFilters from './MediaFilters';
import MediaGridView from './MediaGridView';
import MediaTableView from './MediaTableView';
import PaginationFooter from './PaginationFooter';

const MediaList = ({
  medias,
  isLoading,
  count,
  selectedMediaIds,
  searchMedia,
  onSearchMediaChange,
  onMediaToggle,
  onBulkToggle,
  displayedStatus = null,
  onClearSelection,
  resolveBulkActions,
  onValidateMedia,
  viewMode,
  setViewMode,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  setHasRejectedMedias,
  onSelectAllMedias,
}) => {
  const handlePageChange = useCallback(
    (page, newPageSize) => {
      setCurrentPage(page);
      if (newPageSize !== pageSize) {
        setPageSize(newPageSize);
        setCurrentPage(1);
      }
    },
    [pageSize]
  );

  const pageSizeOptions = useMemo(
    () => PAGINATION_OPTIONS[viewMode] || PAGINATION_OPTIONS.large,
    [viewMode]
  );

  // if (isLoading) return <Spin />;

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <MediaFilters
        searchMedia={searchMedia}
        onSearchMediaChange={onSearchMediaChange}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        onSelectAllMedias={onSelectAllMedias}
      />
      <MediaActions
        medias={medias}
        selectedMediaIds={selectedMediaIds}
        displayedStatus={displayedStatus}
        onClearSelection={onClearSelection}
        resolveBulkActions={resolveBulkActions}
        totalCount={count}
        setHasRejectedMedias={setHasRejectedMedias}
        isLoading={isLoading}
      />

      <div
        style={{
          flex: 1,
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {(viewMode === 'large' || viewMode === 'small') && (
          <MediaGridView
            setHasRejectedMedias={setHasRejectedMedias}
            isLoading={isLoading}
            medias={medias}
            viewMode={viewMode}
            currentPage={currentPage}
            pageSize={pageSize}
            selectedMediaIds={selectedMediaIds}
            onMediaToggle={onMediaToggle}
            onValidateMedia={onValidateMedia}
          />
        )}
        {viewMode === 'list' && (
          <MediaTableView
            isLoading={isLoading}
            medias={medias}
            selectedMediaIds={selectedMediaIds}
            onMediaToggle={onMediaToggle}
            onBulkToggle={onBulkToggle}
          />
        )}
        <PaginationFooter
          currentPage={currentPage}
          pageSize={pageSize}
          total={count || 0}
          onChange={handlePageChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </div>
  );
};

export default MediaList;
